var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPointerUpIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m20.236 13.067-6.632-6.633-.854-.854V21.5h-1.5V5.582l-.853.852-6.634 6.622L2.707 12 12 2.707l9.294 9.294z"
})));
export { SvgPointerUpIcon as ReactComponent };
export default __webpack_public_path__ + "92e79517389c2a1c26342ec34aea9b3c.svg";